<template>
  <zord-button
    label="Back"
    type="button"
    @click="clearTopicSelection"
    is-basic
    has-leading-icon
  >
    <template v-slot:leadingIcon>
      <i class="fal fa-chevron-left" />
    </template>
  </zord-button>

  <zord-card is-padded>
    <div class="questions-form-container">
      <header>
        <zord-heading :level="1" :text="selectedTopic.name" class="faq-heading" />
        <p>{{ t('questions.form.type_question.subheader') }}</p>
      </header>

      <zord-card
        v-for="faq in faqs"
        :key="faq.id"
        :href="`/faqs/${faq.id}`"
        is-primary
        is-interactive
        has-trailing-icon
      >
        <zord-heading :level="4" :text="faq.question" />
        <div class="faq-answer" v-html="faq.answer" />
        <template v-slot:trailingIcon>
          <i class="fal fa-chevron-right" />
        </template>
      </zord-card>

      <p v-html="t('questions.form.type_question.still_need_help')" />

      <slot />

      <textarea
        v-model="form.content"
        class="zord-form-control"
        :form="formId"
        rows="5"
        name="question[content]"
        placeholder="Type your question here"
        required="true"
        maxlength="650"
      />

      <input
        type="hidden"
        name="question[topic_id]"
        :form="formId"
        :value="selectedTopic.id"
      />

      <input
        type="hidden"
        name="question[order_id]"
        :form="formId"
        :value="selectedResultId"
      />

      <zord-button
        :form="formId"
        label="Send"
        is-primary
        style="align-self: flex-start;"
        :disabled="form.content.length === 0"
      />
    </div>
  </zord-card>
</template>

<script>
import { t } from '@/javascripts/config/i18n'
import {
  ZordButton,
  ZordCard,
  ZordHeading
} from '@/javascripts/components/zord'

export default {
  name: 'Form',
  data() {
    return {
      t,
      selectedTopic: this.$parent.state.selectedTopic,
      selectedResultId: this.$parent.state.selectedResult?.order_id,
      form: {
        content: ''
      },
      faqs: this.$parent.state.selectedTopic.frequently_asked_questions
    }
  },
  props: {
    formId: {
      type: String,
      default: ''
    }
  },
  components: {
    ZordButton,
    ZordCard,
    ZordHeading
  },
  methods: {
    clearTopicSelection() {
      this.$parent.resetSelectedTopic()
    }
  }
}
</script>

<style lang="scss" scoped>
  header {
    margin-bottom: var(--spacing-xs);
  }

  .questions-form-container {
    display: flex;
    flex-direction: column;
    gap: var(--spacing);
  }

  p {
    margin-bottom: 0;
  }

  .faq-heading {
    color: var(--secondary-grey);
    font-size: 1.5rem;
    font-weight: 300;
    font-style: italic;
  }
</style>
